import axios from "axios";

const API_URL = `${process.env.REACT_APP_SALINGUNTUNG_API_URL}/api`;

export const getBanners = async () => {
  const response = await axios.get(`${API_URL}/banners/active`);
  return response.data.data;
};

export const getMerchants = async ({ keyword = "", categoryId = "", page = 1, row = 24 } = {}) => {
  const response = await axios.get(`${API_URL}/stores/public`, {
    params: { keyword, category_id: categoryId, page, row },
  });
  return response.data.data;
};

export const getMerchantByCode = async (code) => {
  const response = await axios.get(`${API_URL}/stores/public/${code}`);
  return response.data.data;
};
